// Mixins.
import notification from './notification'

export default {
    methods: {
        handleError(error) {
            let message = null

            if (!(error instanceof Object) || !error.response) {
                throw error
            }

            if (error.response.status == 400) {
                message = error.response.data.error || null
            }
            else if (error.response.status == 401) {
                message = error.response.data.error || null
            }
            else if (error.response.status == 403) {
                this.$router.push({name: '403', params: {notification: false}})
            }
            else if (error.response.status == 422) {
                let messages = ''

                for (const key in error.response.data) {
                    if (Array.isArray(error.response.data[key])) {
                        messages += error.response.data[key].map(map => `<li>${map}</li>`).join('')
                        continue
                    }

                    messages.push(error.response.data[key])
                }

                message = `<ul class="m-0">${messages}</ul>`
            }
            else {
                message = 'Erro inesperado, por favor contate o suporte do sistema.'
            }

            if (message) {
                this.showDangerNotification('Erro de validação', message)
            }
        }
    },
    mixins: [notification]
}